var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"data-toggle":"tooltip","data-placement":"top","title":_vm.schedule.status}},[_c('i',{staticClass:"status-icon fas fa-circle",class:{'text-success' : _vm.schedule.is_past, 'text-warning' : _vm.schedule.is_now, 'text-info' : _vm.schedule.is_coming }})])
}
var staticRenderFns = []

export { render, staticRenderFns }